import { setupWorker } from 'msw';
import { paniniHandlers } from '@redge/paninievernext';

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...paniniHandlers());
